import * as React from "react";
import Icon from "./icons";
import navigation from "../data/footernav";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation("common");
  const title = t("header.designing") + " " + t("header.multiAgentSystems");
  return (
    <div className="mt-6 rounded  ">
      <div className="    " aria-labelledby="footerHeading">
        <h2 id="footerHeading" className="sr-only">
          {t("footer.title", "Footer")}
        </h2>
        <div
          style={{ height: "400px" }}
          className="mb-14 h-full   rounded bg-indigo-700 py-6   px-6 "
        >
          <div className="    h-full flex-col">
            <div className="xl:grid   flex-grow xl:grid-cols-3 xl:gap-8">
              <div className="grid grid-cols-2 gap-8 xl:col-span-2">
                <div className="md:grid md:grid-cols-2 md:gap-8">
                  <div>
                    <h3 className="text-sm font-semibold text-white tracking-wider uppercase">
                      {t("footer.resources")}
                    </h3>
                    <ul className="mt-4 space-y-4">
                      {navigation.resources.map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className="text-base text-gray-300 hover:text-white"
                          >
                            {item.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="md:grid md:grid-cols-2 md:gap-8"></div>
              </div>
            </div>
            <div className="mt-28   pt-8 md:flex md:items-center md:justify-between">
              <div className="flex mb-8   space-x-6 md:order-2">
                {navigation.social.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:text-gray-300"
                  >
                    <span className="sr-only">{item.name}</span>
                    <item.icon className="h-6 w-6" aria-hidden="true" />
                  </a>
                ))}
              </div>

              <p className="mt-8 mb-8 text-sm text-white md:mt-0 md:order-1">
                &copy; {title} |{" "}
                <Link to="/privacy" className="  hover:text-white">
                  {" "}
                  {t("footer.privacyPolicy")}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
